<template>
<!-- inventory records 库存记录 -->
  <div class="inventory_records_page">
    <header class="header">
      <img @click="goBack" src="./../../../../assets/images/canEat/arrow_left.png" alt="">
    </header>
    <div class="list">
      <!-- 循环 -->
      <!-- <div v-for="item in arr" :key="item.id" :class="['add_operation', {'active': } ]"> -->
    <div v-for="(item, index) in inventoryDatas" :key="index"
    :class="['add_operation',{'active': item.activeClass} ]">
        <div class="image_upload">
          <img :src="item.pic ? item.pic : require('./../../../../assets/images/feedRecord/add.png')" alt="">
        </div>
        <div class="add_info">
          <div class="input_item">
            <h3 class="title">{{item.productName}}</h3>
          </div>
          <div class="input_item item">
            <p class="tit">阶段：{{item.productSeries}}</p>
          </div>
          <div class="input_item item">
            <p class="tit">规格：{{item.specs}}g</p>
          </div>
          <div class="input_item item num_item">
            <span>数量：</span>
            <div class="nums">
              <span class="symbol" @click="counter('decrease', item.id)">-</span>
              <i class="count">{{item.num}}</i>
              <span class="symbol" @click="counter('increase', item.id)">+</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div>
      <span @click="sweepCode">扫码添加</span>
      <span
    @click="manuallyAdd">手动添加</span>
    </div> -->
    <div class="save_btn" @click="handleSave"><span class="save">保存</span></div>
    <van-dialog v-model="show" show-cancel-button overlayClass="mask"
    @confirm="confirm"
    @cancel="cancel">
      <div>
        <p>数量为0时，该条记录将消失，是否确定删除？</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import feedRecordsApi from "@/utils/axiosApi/feedRecordsApi"
import { Toast } from 'vant';

  export default {
    name: 'InventoryRecords',
    data() {
      return {
        value: '',
        show: false,
        value1: 0,
        activeClass: false,
        curIdx: '',
        state: null,
        inventoryDatas: [],
      }
    },
  //   computed: { // 在computed中动态监控
  //     ...mapState({
  //       arr: state => state.arr,
  //     }),
  //  },
    mounted() {
      this.state = this.$route.query.state
      this.getFeedRecords()
    },
    destroyed() {
      clearTimeout(this.timeOut)
    },
    methods: {
      getFeedRecords() { // 查询奶粉库存
        feedRecordsApi.getHistoryRepertory({crmId: 'CRM000000000043658926', state: this.state}, (res) => {
          console.log(res.data.data, '奶粉库存')
          this.inventoryDatas = res.data.data
        })
      },
      goBack() {
        this.$router.back()
      },
      // sweepCode() { // 扫码添加

      // },
      // manuallyAdd() { // 手动添加
      // if(this.arr.length >= 3) {
      //   alert('最多只能添加三种类别')
      // } else {
      //   this.$router.push({
      //     path: '/manuallyAdd'
      //   })
      // }
      // },
      counter(type, idx) { // 加减操作
      this.curIdx = idx // 把点击的那一项赋值给curIdx
        if(type == 'decrease') { // 递减
        this.inventoryDatas = this.inventoryDatas.map((item) => {
          item.activeClass = false // 点击的样式
          if (item.num > 1) {
            if(item.id == idx) {
				      item.num --;
            }
			    } else {
            if(item.id == idx) {
              item.activeClass = true // 点击的样式
              this.show = true
            }
		      }
          return item
          })
          //
        }
        else if (type == 'increase') { // 递增
        let obj = this.inventoryDatas.find((item) => {
          return item.id == this.curIdx
        })
        this.inventoryDatas = this.inventoryDatas.map((item) => {
          item.activeClass = false // 点击的样式
          if (item.num < 20) {
            if(item.id == idx) {
				      item.num ++;
            }
			    } else {
              // toDo
              Toast('宝宝喜欢吃新鲜奶粉，不要一次囤太多哦~')
		      }
          return item
          })
        }
      },
      confirm() { // 弹框确认按钮
        console.log('我点击了确认按钮')
        // 删除此条数据
        this.inventoryDatas = JSON.parse(JSON.stringify(this.inventoryDatas))
        // this.inventoryDatas = this.inventoryDatas.filter((item) => {
        //   return item.id !== this.curIdx
        // })
        // this.$store.commit('SAVE_INVENTORY', this.inventoryDatas);
        //
        let obj = this.inventoryDatas && this.inventoryDatas.find((item) => {
          return item.id == this.curIdx
        })

        // 删除此条信息
        feedRecordsApi.getDelRepertory({id: obj.id}, (res) => {
          if(res.code == '200') {
            this.getFeedRecords()
            this.timeOut = setTimeout(() => {
              this.$router.push({
                path: '/babyBarn'
              })
            }, 200)
          }
        })
      },
      cancel() {
        console.log('我点击了取消按钮')
        this.inventoryDatas = this.inventoryDatas.map((item) => {
          item.activeClass = false // 点击的样式
          return item
        })
      },
      handleSave() { // 修改完数量点击保存
      let obj = this.inventoryDatas.find((item) => {
        return item.id == this.curIdx
      })
      console.log(obj, 184)
        feedRecordsApi.postUpdateRepertory({}, {memberId:'CRM000000000043658926',id: obj.id, specs: obj.specs,num: obj.num, weight: obj.weight}, (res) => {
            // if(res.data == 1) {
            //   this.getFeedRecords()
            // }
          if(res.code == '200') {
            this.$router.push({
              path: '/babyBarn'
            })
          }
        })

      }
    }
  }
</script>

<style lang="less" scoped>
.inventory_records_page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  ::-webkit-scrollbar {
    display: none;
  }
  .header {
    width: 100%;
    height: 52px;
    padding: 15px 13px 17px;
    box-sizing: border-box;
    background: #FFFFFF;
    >img {
      width: 10px;
      height: 20px;
    }
  }
  .list {
    width: 100%;
    flex: 1;
    overflow-x: auto;
    padding: 0 13px;
    box-sizing: border-box;
    .add_operation { // 每一个记录项
      width: 100%;
      display: flex;
      padding: 14px 0 14px 4px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 0px 3px 10px 0px rgba(200, 201, 204, 0.5);
      border-radius: 8px;
      margin-bottom: 7px;
      .image_upload {
        width: 92px;
        height: 92px;
        >img {
          width: 92px;
          height: 92px;
        }
      }
      .add_info {
        width: 100%;
        flex: 1;
        padding-left: 12px;
        box-sizing: border-box;
        .input_item {
          width: 100%;
          .title {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
          }
          .tit {
            height: 18px;
            font-size: 12px;
            color: #999999;
            line-height: 18px;
          }
          &.item {
            margin-top: 8px;
          }
          &.num_item {
            height: 24px;
            display: flex;
            >span {
              font-size: 12px;
              color: #999999;
              line-height: 24px;
            }
            .nums {
              width: 79px;
              height: 24px;
              display: flex;
              border-radius: 3px;
              border: 1px solid #DCDDDC;
              line-height: 24px;
              .symbol {
                font-size: 12px;
                flex: 1;
                text-align: center;
                color: #666666;
              }
              .count {
                flex: 1;
                text-align: center;
                font-style: normal;
                border-left: 1px solid #DCDDDC;
                border-right: 1px solid #DCDDDC;
                color: #666666;
              }
            }
          }
        }
      }
      &.active {
        border: 1px solid red;
      }
    }
  }
  .save_btn {
    width: 100%;
    height: 58px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px -1px rgba(0, 0, 0, 0.2);
    padding: 11px 45px 11px 46px;
    box-sizing: border-box;
    .save {
      width: 100%;
      display: block;
      height: 36px;
      background: linear-gradient(270deg, #D4A437 0%, #E5BF5D 100%);
      border-radius: 30px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
    }
  }
  .van-dialog {
    width: 270px;
  }
  .van-dialog /deep/ .van-dialog__content {
    padding: 29px 24px 15px 33px;
    box-sizing: border-box;
  }
  .van-dialog /deep/ .van-dialog__content >div >p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
    /deep/ .van-dialog__footer {
      height: 41px;
    }
    /deep/ .van-dialog__footer .van-button {
      height: 41px;
    }
    /deep/ .van-dialog__footer .van-button .van-button__content {
      height: 41px;
      background:  #FFFFFF;
      border-radius: 8px;
      overflow: hidden;
      font-size: 16px;
      color: #333333;
    }
    /deep/ .van-dialog__footer .van-button.van-dialog__confirm .van-button__content .van-button__text {
      color: #F470BE;
    }
}
</style>